import NoteDetailsContainer from "./NoteDetailsContainer";
export default NoteDetailsContainer;
